import { paymentStatusTabs, type PaymentStatusFilter } from '../../../data/paymentFilters'
import { cn } from '../../../utils/cn'

type PaymentStatusTabsProps = {
  value: PaymentStatusFilter
  onChange: (status: PaymentStatusFilter) => void
}

export const PaymentStatusTabs = ({ value, onChange }: PaymentStatusTabsProps) => (
  <div className="flex flex-wrap items-center gap-[7px]" role="tablist" aria-label="Payment status">
    {paymentStatusTabs.map((tab) => {
      const active = tab.value === value

      return (
        <button
          key={tab.value}
          type="button"
          role="tab"
          aria-selected={active}
          onClick={() => onChange(tab.value)}
          className={cn(
            'flex h-[37px] items-center justify-center rounded-[8px] border border-solid border-dash-lime px-[10px] font-host text-[14px] font-medium leading-normal text-black',
            active ? 'bg-[rgba(186,214,126,0.46)]' : 'bg-transparent',
            tab.value === 'all' && 'min-w-[60px]',
            tab.value === 'paid' && 'min-w-[59px]',
            tab.value === 'pending' && 'min-w-[87px]',
            tab.value === 'failed' && 'min-w-[73px]',
            tab.value === 'refunded' && 'min-w-[98px]',
          )}
        >
          {tab.label}
        </button>
      )
    })}
  </div>
)
